import { DataView } from 'primereact/dataview';
import { useEffect, useState } from 'react';
import PageWrapper from '../../../../components/Display/PageWrapper';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { useLanguageContext } from '../../../../contexts/LanguageContext';
import { useNavigationContext } from '../../../../contexts/NavigationContext';
import { privateFetch } from '../../../../utils/apiHelper';
import NewsDetail from './NewsDetail';
import NewsItem from './NewsItem';
import NewsManager from './NewsManager';
import styles from "../../../../components/Display/Wrapper.module.scss";

function NewsPage({ isActive }) {
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [newsDetail, setNewsDetail] = useState(undefined);
  const [newsList, setNewslist] = useState([]);
  const [loading, setLoading] = useState(false);
  const { accountContext } = useAccountContext();
  const { setActiveView, navigationContext } = useNavigationContext();
  const [emptyPayload, setEmptyPayload] = useState(false);
  const [isDuplicate, setIsDuplicate] = useState(false);
  const { languageContext } = useLanguageContext();
  const [layout, setLayout] = useState('grid');

  useEffect(() => {
    fetchNewsList();
  }, [languageContext]);

  const fetchNewsList = async () => {
    await privateFetch(
      'GET',
      'chiennoir',
      `/cu/${accountContext.id}/news/?lang=${languageContext}`
    ).then((res) => {
      setNewslist(res);
    });
  };

  const fetchNewsDetail = async () => {
    await privateFetch(
      'GET',
      'resources',
      `/cu/${accountContext.id}/news/${navigationContext.activeNewsId}/?lang=${languageContext}`
    ).then((res) => {
      if (res) setNewsDetail(res);
    });
  };

  const createNews = async (newsForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'chiennoir',
      `/cu/${accountContext.id}/news/`,
      "L'article a bien été ajouté",
      JSON.stringify(newsForm)
    ).then(() => {
      fetchNewsList();
      setLoading(false);
      setPanelIsOpen(false);
      setNewsDetail(undefined);
      setEmptyPayload(true);
      setIsDuplicate(false);
    });
  };

  const updateNews = async (newsForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'resources',
      `/cu/${accountContext.id}/news/${navigationContext.activeNewsId}/?lang=${languageContext}`,
      "L'article a bien été modifié",
      JSON.stringify(newsForm)
    ).then(() => {
      fetchNewsList();
      fetchNewsDetail();
      setLoading(false);
      setPanelIsOpen(false);
    });
  };

  const deleteNews = async (news) => {
    await privateFetch(
      'DELETE',
      'resources',
      `/cu/${accountContext.id}/news/${news.id}/`,
      "L'article a bien été supprimé"
    ).then(() => {
      fetchNewsList();
      setNewsDetail(undefined);
    });
  };

  const handleClickNews = (news) => {
    setActiveView("cngnews", news, "activeNewsId");
  };

  useEffect(() => {
    if (navigationContext.activeNewsId) {
      fetchNewsDetail();
    } else setNewsDetail(undefined);
  }, [navigationContext, languageContext]);

  const handleOpenManager = () => {
    setPanelIsOpen(true);
    setEmptyPayload(false);
  };

  const goBackNewsAction = {
    onClick: handleClickNews,
    icon: 'pi-chevron-left',
    label: 'Retour à la liste'
  };

  const newNewsAction = {
    onClick: handleOpenManager,
    label: 'Ajouter une actualité',
    icon: 'pi-plus'
  };
  const toggleLayout = () => {
    setLayout(layout === 'grid' ? 'list' : 'grid');
  };

  const changeLayoutAction = {
    onClick: toggleLayout,
    ariaLabel: "changer le mode d'affichage",
    icon: layout == "grid" ? "pi-list" : 'pi-th-large'
  };



  return (
    <div className={`h-full w-full flex-col ${isActive ? 'flex' : 'hidden'}`}>
      <PageWrapper
        label="Actualités"
        labelAction={handleClickNews}
        actions={newsDetail ? [goBackNewsAction] : [changeLayoutAction, newNewsAction]}
        detail={newsDetail}>
        {newsDetail && !isDuplicate ? (
          <NewsDetail
            news={newsDetail}
            handleUpdateNews={handleOpenManager}
            handleDelete={deleteNews}
          />
        ) : (
          <div className={styles.pageContentContainer}>
            <div className={` ${layout === 'grid' ? styles.gridLayout : styles.listLayout}`}>
              {newsList.map((news, index) => (
                <NewsItem
                  layout={layout}
                  key={index}
                  news={news}
                  handleClickNews={() => handleClickNews(news)} />
              ))}
            </div>
          </div>
        )}
      </PageWrapper>
      <NewsManager
        isOpen={panelIsOpen}
        onClose={setPanelIsOpen}
        news={newsDetail}
        onCreate={createNews}
        onUpdate={updateNews}
        loading={loading}
        emptyPayload={emptyPayload}
        isDuplicate={isDuplicate}
      />
    </div>
  );
}

export default NewsPage;
